(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/adobe-target-notification/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/components/adobe-target-notification/assets/javascripts/prescript.js');

var svs = svs || {};
svs.components = svs.components || {};
svs.components.adobeTargetNotification = svs.components.adobeTargetNotification || {};


 })(window);